// extracted by extract-css-chunks-webpack-plugin
module.exports = {"content":"hjqfO22vCkYzsIbjvx03"};